import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export const FocusScreen = ({ onComplete }) => {
  const [countdown, setCountdown] = useState(5);
  
  useEffect(() => {
    if (countdown <= 0) {
      onComplete();
      return;
    }
    
    const timer = setTimeout(() => {
      setCountdown(countdown - 1);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, [countdown, onComplete]);
  
  const handleSkip = () => {
    onComplete();
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center p-8 relative" data-testid="focus-screen">
      <div className="text-center space-y-12">
        <div className="space-y-4">
          <h2 className="text-3xl font-heading text-slate-100">
            Zihni Dinginleştir
          </h2>
          <p className="text-slate-400 text-lg tracking-wide">
            Yavaşça nefes al. Zorlamadan gözlemle.
          </p>
        </div>
        
        <motion.div
          className="w-48 h-48 mx-auto rounded-full border-2 border-violet-500/30 flex items-center justify-center"
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.3, 0.6, 0.3]
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: 'easeInOut'
          }}
        >
          <div className="w-40 h-40 rounded-full border border-cyan-500/20" />
        </motion.div>
        
        <div className="text-slate-600 text-sm">
          {countdown}
        </div>
      </div>
      
      {/* Skip button */}
      <button
        onClick={handleSkip}
        className="absolute bottom-8 right-8 text-slate-600 hover:text-slate-400 text-sm transition-colors z-50"
        data-testid="focus-skip-btn"
      >
        Atla
      </button>
    </div>
  );
};
